// Keeps a LoRa list-page table's max-height in sync with the actual space
// available below it, instead of guessing a fixed window.innerHeight offset
// (fragile — the chrome above/below the table differs per page and changes
// whenever the layout does). Measures the table's own top position, so it
// stays correct regardless of breadcrumb/filter-bar/sidebar layout changes.
export default {
  data() {
    return {
      tableHeight: 400
    }
  },
  mounted() {
    this.$nextTick(this.updateLoraTableHeight)
    window.addEventListener('resize', this.updateLoraTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateLoraTableHeight)
  },
  methods: {
    updateLoraTableHeight() {
      const el = this.$el.querySelector('.app-table')
      if (!el) return
      const top = el.getBoundingClientRect().top
      // 20px footer bar + 20px breathing room below the table.
      this.tableHeight = Math.max(200, window.innerHeight - top - 40)
    }
  }
}
